import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      filingStatus: {
        COMPANY_FILINGS: 'Company Filings',
        INVOICE_ENFORCEMENT: 'Invoice Enforcement',
        OVERDUE_TAX_DEBT: 'Overdue Tax Debt',
        OVERDUE_SOCIAL_INSURANCE: 'Overdue Social Insurance',
        IN_THE_PAST_5_YEARS: 'in the past 5 years',
        DECLARE_1:
          "The following public filing data is for information purposes only and is not the official record. Certified copies can only be obtained from Official sources. Due to the infrequent updates of the public filing data, the data below only reflect the Company's historical filing records at the publication date and may not represent the Company's current filing status.",
        DECLARE_2_1: 'Data on overdue tax debt cover ',
        DECLARE_2_2: '34 provinces',
        DECLARE_2_3:
          ' in Vietnam with significant amounts of debt. Please contact us if you require additional research on areas that are not currently available.',
        DECLARE_3:
          'Overdue social insurance data covers all 34 provinces of Vietnam.',
        PUBLICATION_DATE: 'Publication Date',
        AMOUNT: 'Amount',
        DEPARTMENT: 'Department',
        OVERDUE_TAX_DEBT_HISTORY: 'Overdue Tax Debt History',
        INVOICE_ENFORCEMENT_HISTORY: 'Tax Enforcement History',
        NO_DATA_TAX_DEBT: 'This company has no overdue tax debt',
        NO_DATA_INVOICE: 'This company has no invoice enforcement',
        NO_DATA_SOCIAL_INSURANCE:
          'This company has no overdue social insurance',
        TOOLTIP_INVOICE:
          'Tax enforcement is a measure that tax authorities apply to businesses committing tax violations. Businesses are not permitted to use invoices during the enforcement period. If a business uses an enforced invoice intentionally during that time, such as in a purchase and sale transaction involving an invoice, these invoices are deemed illegal.',
        OUTSTANDING_MONTHS: 'Outstanding Months',
        ENFORCEMENT_TYPE: 'Enforcement Type',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      filingStatus: {
        COMPANY_FILINGS: 'Tình Trạng Nợ Thuế',
        INVOICE_ENFORCEMENT: 'Cưỡng Chế Hóa Đơn',
        OVERDUE_TAX_DEBT: 'Quá Hạn Nợ Thuế',
        OVERDUE_SOCIAL_INSURANCE: 'Quá Hạn Bảo Hiểm Xã Hội',
        IN_THE_PAST_5_YEARS: 'trong 5 năm qua',
        DECLARE_1:
          'Dữ liệu lưu trữ công khai tại đây chỉ dành cho mục đích cung cấp thông tin và không phải là hồ sơ chính thức. Bản sao được chứng thực chỉ có thể lấy từ các nguồn Chính thức. Do dữ liệu nộp hồ sơ công khai không được cập nhật thường xuyên, dữ liệu dưới đây chỉ phản ánh bản ghi lịch sử về tình trạng nợ thuế của Công ty vào ngày được công bố và có thể không đại diện cho tình trạng nợ thuế hiện tại của Công ty.',
        DECLARE_2_1: 'Dữ liệu quá hạn nợ thuế có sẵn bao trùm ',
        DECLARE_2_2: '34 tỉnh thành',
        DECLARE_2_3:
          ' tại Việt Nam với số nợ lớn. Vui lòng liên hệ chúng tôi nếu bạn cần nghiên cứu thêm về các địa bàn chưa có sẵn thông tin.',
        DECLARE_3:
          'Dữ liệu về quá hạn nợ bảo hiểm xã hội có sẵn bao trùm 34 tỉnh thành tại Việt Nam.',
        PUBLICATION_DATE: 'Ngày Công Bố',
        AMOUNT: 'Số Tiền',
        DEPARTMENT: 'Cơ Quan Bảo Hiểm',
        OVERDUE_TAX_DEBT_HISTORY: 'Lịch Sử Quá Hạn Nợ Thuế',
        INVOICE_ENFORCEMENT_HISTORY: 'Lịch Sử Cưỡng Chế Nợ Thuế',
        NO_DATA_TAX_DEBT: 'Không có bản ghi quá hạn nợ thuế',
        NO_DATA_INVOICE: 'Không có bản ghi cưỡng chế hóa đơn',
        NO_DATA_SOCIAL_INSURANCE: 'Không có bản ghi nợ bảo hiểm',
        TOOLTIP_INVOICE:
          'Cưỡng chế nợ thuế là biện pháp cơ quan thuế áp dụng với các doanh nghiệp có hành vi vi phạm thuế. Khi bị cưỡng chế, doanh nghiệp không được phép sử dụng hóa đơn cho đến khi có quyết định cho sử dụng lại. Nếu doanh nghiệp vẫn cố tình sử dụng hóa đơn bị cưỡng chế, ví dụ, thực hiện một giao dịch mua và bán được cấp hóa đơn, những hóa đơn này được coi là bất hợp pháp.',
        OUTSTANDING_MONTHS: 'Số Tháng Chậm Đóng',
        ENFORCEMENT_TYPE: 'Loại Cưỡng Chế',
      },
    },
  }),
)
